import { useTranslation } from '@dagens/frontend-i18n';

import { Email } from './email';
import { Feedback } from './feedback';
import { InviteUser } from './invite-user';
import { useUsers } from './use-users';
import Container from '@carrot-deprecated/container';
import Typography from '@carrot-deprecated/typography';
import { useAppSelector } from '_common/hooks/reduxHooks';

export const EditUsers = () => {
  const { t } = useTranslation();
  const { accountName } = useAppSelector(({ auth }) => {
    return {
      accountName: auth.name
    };
  });

  const {
    loginEmails,
    hideRemoveButton,
    feedback,
    onInvite,
    onInviteInputChange,
    onRemove,
    onRemoveSuccess,
    onRemoveError
  } = useUsers();

  return (
    <Container mb="xl">
      <Typography variant="paragraphBold" as="p" mb="xs">
        {t('consumer:UsersWithAccess', { accountName })}
      </Typography>
      <ul>
        {loginEmails.map(email => {
          return (
            <Email
              key={email}
              email={email}
              hideRemoveButton={hideRemoveButton}
              onRemove={onRemove}
              onRemoveSuccess={onRemoveSuccess}
              onRemoveError={onRemoveError}
            />
          );
        })}
      </ul>
      <InviteUser
        onInvite={onInvite}
        onInviteInputChange={onInviteInputChange}
      />
      <Feedback value={feedback} />
    </Container>
  );
};
